import { useEffect, useState } from 'react'

import { SubOptions } from '@/components/header'

interface UseClickOutsideProps {
  isBiggerMobile: boolean
}
export const useClickOutside = ({ isBiggerMobile }: UseClickOutsideProps) => {
  const [open, setOpen] = useState(false)
  const [showSubOptions, setShowSubOptions] = useState<SubOptions>({
    index: -1,
    show: false,
  })

  const handleClick = (event: MouseEvent) => {
    if (
      (event.target as Element).matches('.button-close-modal') ||
      (event.target as Element).matches('#header-container')
    ) {
      setOpen(false)
      setShowSubOptions({ index: -1, show: false })
    }
  }

  const handleClickEscape = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      setOpen(false)
      setShowSubOptions({ index: -1, show: false })
    }
  }

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!isBiggerMobile) {
      document.addEventListener('click', (e) => handleClick(e), {
        passive: true,
      })

      document.addEventListener('keydown', (e) => handleClickEscape(e), {
        passive: true,
      })

      return () => {
        document.removeEventListener('click', handleClick)
        document.removeEventListener('keydown', handleClickEscape)
      }
    }
  }, [open, isBiggerMobile])

  return { open, setOpen, showSubOptions, setShowSubOptions }
}
